interface LogoIconProps {
  className?: string;
  "aria-hidden"?: boolean;
}

export const LogoIcon = ({ className, ...props }: LogoIconProps) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-label="AI Deck logo"
    fill="currentColor"
    {...props}
  >
    <rect x="3" y="4" width="13" height="2.5" rx="1.25" />
    <rect x="17" y="4" width="4" height="2.5" rx="1.25" fill="#94a3b8" />
    <rect x="3" y="8.5" width="6" height="2.5" rx="1.25" fill="#94a3b8" />
    <rect x="10" y="8.5" width="11" height="2.5" rx="1.25" />
    <rect x="3" y="13" width="10" height="2.5" rx="1.25" />
    <rect x="14" y="13" width="7" height="2.5" rx="1.25" fill="#94a3b8" />
    <rect x="3" y="17.5" width="5" height="2.5" rx="1.25" fill="#94a3b8" />
    <rect x="9" y="17.5" width="12" height="2.5" rx="1.25" />
  </svg>
);
